'use strict';

module.exports = comment;

/* Stringify a comment `node`. */
function comment(ctx, node) {
  return '<!--' + node.value + '-->';
}



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-to-html/lib/comment.js
// module id = 175
// module chunks = 96961042003272 139266963665775